import { QuestionFormat } from '../enum/question-format';
import { QuestionType } from '../enum/question-type.enum';
import { MultiLangStr } from '../model/multi-lang-str.model';
import { CandidateResRes } from './candidate-response.response';

export interface StartTestRes {
  test: TestRes;
  candidateResponse: CandidateResRes;
  inProgress: boolean;
}

export enum TestPattern {
  NEET = 'neet',
  JEE_MAIN = 'jee',
  JEE_ADVANCE = 'jee-advance',
  CHAPTER_TEST = 'chapter-test',
  MHCET_MATH = 'mhcet-math',
  MHCET_BIOLOGY = 'mhcet-biology',
  NTA = 'nta',
  STANDARD = 'standard',
}

export interface TestRes {
  id: string;
  businessId: string;
  name: MultiLangStr;
  description: MultiLangStr;
  instruction: MultiLangStr;
  schedules: TestSchedule[];
  schedule: TestSchedule;
  examList: MiniExam[];
  fullMark: number;
  duration: number;
  sectionList: Section[];
  timed: boolean;
  status: string;
  mode: string;
  level: number;
  solutionList: any[];
  createdBy: string;
  createdOn: string;
  modifiedOn: string;
  isStarted: boolean;
  active: boolean;
  languages: string[];
  pattern: TestPattern; //jee, neet, standard
  timeTaken: number; //Front End state
  attempted: boolean; //Front end state
  startTime: number; //Front end state
  endTime: number; //Front end state
}

export interface Proctoring {
  forceFullScreen: boolean;
  screenSwitchLimit: number;
}

export interface MiniExam {
  id: string;
  name: MultiLangStr;
}

export interface Section {
  id: string;
  name: MultiLangStr;
  instruction: MultiLangStr;
  maxTime: number;
  timed: boolean;
  fullMark: number;
  questionList: Question[];
  level: number;
  shuffling: boolean;
  active: boolean; //Front end state
  timeTaken: number; //Front end state
  attempted: boolean; //Front end state
  order: number;
}

export interface Question {
  id: string;
  description: MultiLangStr;
  instruction: MultiLangStr;
  type: QuestionType;
  topicList: MiniTopic[];
  subject: MiniSubject;
  timed: boolean;
  answer: any;
  marking: Marking;
  maxTime: number;
  optionList: Option[];
  mediaList: any;
  bonus: boolean;
  shuffling: boolean;
  format: QuestionFormat;
  paragraph?: QuestionParagraph;
  order: number;
  counter: number;
  active: boolean; //Front end state
  attempted: boolean; //Front end state
  candidateAnswer: MultiLangStr | null; //Front end state
  timeTaken: number; //Front end state
  markedForRevisit: boolean; //Front end state
  saved: boolean; //Front end state - JEE pattern: tracks if question was explicitly saved via SAVE & NEXT
  index: number; //Front end state
}

export interface QuestionParagraph {
  id: string;
  paragraph: MultiLangStr;
  isParagraph: boolean;
}

export interface MiniTopic {
  id: string;
  name: MultiLangStr;
}

export interface MiniSubject {
  id: string;
  name: MultiLangStr;
}

export interface Marking {
  positive: number;
  negative: number;
  partial: number;
}

export interface Option {
  id: string;
  value: MultiLangStr;
  correct: boolean;
  selected: boolean;
}

export interface TestSchedule {
  startDate: number;
  endDate: number;
  batches: MiniBatch[];
  proctoring: Proctoring;
}

export interface MiniBatch {
  id: string;
  name: MultiLangStr;
}
